export const reConstructionCategoryConstants = {
	GetKinds: {
		FAILURE : 'GET_KINDS_CONSTRUCTION_CATEGORY_FAILURE',
		REQUEST : 'GET_KINDS_CONSTRUCTION_CATEGORY_REQUEST',
		SUCCESS : 'GET_KINDS_CONSTRUCTION_CATEGORY_SUCCESS'
	},
	GetList: {
		FAILURE : 'GET_LIST_CONSTRUCTION_CATEGORY_FAILURE',
		REQUEST : 'GET_LIST_CONSTRUCTION_CATEGORY_REQUEST',
		SUCCESS : 'GET_LIST_CONSTRUCTION_CATEGORY_SUCCESS'
	},
	GetVolumeList: {
		FAILURE : 'GET_LIST_CONSTRUCTION_CATEGORY_VOLUME_FAILURE',
		REQUEST : 'GET_LIST_CONSTRUCTION_CATEGORY_VOLUME_REQUEST',
		SUCCESS : 'GET_LIST_CONSTRUCTION_CATEGORY_VOLUME_SUCCESS'
	},
	GetChilds: {
		FAILURE : 'GET_CHILDS_CONSTRUCTION_CATEGORY_FAILURE',
		REQUEST : 'GET_CHILDS_CONSTRUCTION_CATEGORY_REQUEST',
		SUCCESS : 'GET_CHILDS_CONSTRUCTION_CATEGORY_SUCCESS'
	},
	getPagedAll: {
		FAILURE : 'GET_All_PAGED_CATEGORIES_LIST_FAILURE',
		REQUEST : 'GET_All_PAGED_CATEGORIES_LIST_REQUEST',
		SUCCESS : 'GET_All_PAGED_CATEGORIES_LIST_SUCCESS'
	},
	getPagedAudit: {
		FAILURE : 'GET_AUDIT_PAGED_CATEGORIES_LIST_FAILURE',
		REQUEST : 'GET_AUDIT_PAGED_CATEGORIES_LIST_REQUEST',
		SUCCESS : 'GET_AUDIT_PAGED_CATEGORIES_LIST_SUCCESS'
	},
	Find: {
		FAILURE : 'FIND_CONSTRUCTION_CATEGORY_FAILURE',
		REQUEST : 'FIND_CONSTRUCTION_CATEGORY_REQUEST',
		SUCCESS : 'FIND_CONSTRUCTION_CATEGORY_SUCCESS'
	},
	create: {
		FAILURE : 'CREATE_CATEGORY_FAILURE',
		REQUEST : 'CREATE_CATEGORY_REQUEST',
		SUCCESS : 'CREATE_CATEGORY_SUCCESS'
	},
	update: {
		FAILURE : 'UPDATE_CATEGORY_FAILURE',
		REQUEST : 'UPDATE_CATEGORY_REQUEST',
		SUCCESS : 'UPDATE_CATEGORY_SUCCESS'
	},
	delete: {
		FAILURE : 'DELETE_CATEGORY_FAILURE',
		REQUEST : 'DELETE_CATEGORY_REQUEST',
		SUCCESS : 'DELETE_CATEGORY_SUCCESS'
	},
	restore: {
		FAILURE : 'RESTORE_CATEGORY_FAILURE',
		REQUEST : 'RESTORE_CATEGORY_REQUEST',
		SUCCESS : 'RESTORE_CATEGORY_SUCCESS'
	},
	CLEAR: 'CLEAR_CONSTRUCTION_CATEGORY'
}